/**
 * 콘텐츠·섬네일 카드 격자의 모바일 규칙 — xs(600px 미만)에서는 **한 줄에 한 장**이다.
 *
 * 🔑 두 장을 우겨 넣으면 실물이 손톱만 해져 무엇인지 안 보인다. sm 부터는 격자마다 제 열 수를 쓴다.
 * ⚠️ 따르지 않는 것 — 아이콘·로고·칩 타일 · 수치 타일 · 사진만 있는 작은 정사각 미리보기 묶음
 *   (홈 결과의 대표 콘텐츠·폴더 표지·하루 묶음 카드처럼 한 장 안에 컷을 나눠 까는 것).
 */

/** CSS 격자(`gridTemplateColumns`)의 xs 값 — 한 열 */
export const CARD_GRID_XS_COLUMNS = 'minmax(0, 1fr)';

/** 줄 배치처럼 열을 JS 로 셈하는 격자가 「한 줄에 한 장」으로 바꾸는 경계 — 이 이름 **미만**이 모바일이다 */
export const CARD_GRID_SINGLE_COLUMN_BELOW = 'sm';
